import api from "@/lib/api";

export const C = { teal: "#0D5C63", deep: "#08363A", orange: "#F26419", ivory: "#FAF6EB", line: "#E9E2D2", ink: "#1A1A1A" };
export const HERO_IMG = "https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";
export const AADHAAR_MAX = 1024 * 1024;
export const AADHAAR_EXT = ["pdf", "jpg", "jpeg", "png"];
export const TSHIRT = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];
export const BLOOD = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Don't Know"];
export const GENDERS = ["Male", "Female", "Other"];

export const DEFAULT_TERMS = `1. I declare that I am medically fit to participate and have trained adequately for the selected distance.
2. I participate entirely at my own risk. GS Mandal, its organisers, sponsors and volunteers are not liable for any injury, loss or damage to me or my belongings.
3. I authorise the organisers to provide first-aid / medical treatment if required, at my cost.
4. The registration fee is non-refundable and non-transferable. Bibs cannot be exchanged.
5. I consent to the use of photographs / videos of me taken at the event for promotional purposes.
6. I will carry my original Aadhaar card at bib collection and follow all instructions of race officials.
7. The organisers may change the route, timing or cancel the event due to unforeseen circumstances.`;

export const inr = (n) => `₹${(Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const longDate = (ymd) => (ymd ? new Date(`${ymd}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "long", year: "numeric" }) : "—");

export function ageOn(dob, onYmd) {
  if (!dob || !onYmd) return null;
  const b = new Date(`${dob}T00:00:00`), d = new Date(`${onYmd}T00:00:00`);
  let a = d.getFullYear() - b.getFullYear();
  if (d.getMonth() < b.getMonth() || (d.getMonth() === b.getMonth() && d.getDate() < b.getDate())) a -= 1;
  return a;
}

export const ageLabel = (r) =>
  r.min_age && r.max_age ? `${r.min_age}–${r.max_age} yrs` : r.min_age ? `${r.min_age}+ yrs` : r.max_age ? `Up to ${r.max_age} yrs` : "All ages";

export function submitToGateway({ gateway_url, access_code, enc_request }) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = gateway_url;
  [["encRequest", enc_request], ["access_code", access_code]].forEach(([name, value]) => {
    const i = document.createElement("input");
    i.type = "hidden"; i.name = name; i.value = value;
    form.appendChild(i);
  });
  document.body.appendChild(form);
  form.submit();
}

export async function startPayment(token) {
  const { data } = await api.post(`/public/marathon/registrations/${token}/payment/initiate`);
  submitToGateway(data);
}

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  const s = e?.response?.status;
  return `${fallback}${s ? ` (HTTP ${s})` : " (network error)"}`;
};

export const ATTEMPT_META = {
  SUCCESS: ["Success", "bg-[#E7F3F1] text-[#0D5C63]"],
  CANCELLED: ["Cancelled", "bg-gray-100 text-gray-700"],
  FAILED: ["Failed", "bg-[#FDECEC] text-[#B02020]"],
  REJECTED: ["Rejected", "bg-[#FDECEC] text-[#B02020]"],
  ABANDONED: ["Abandoned", "bg-amber-50 text-amber-800"],
  IN_PROGRESS: ["In progress", "bg-blue-50 text-blue-700"],
  DUPLICATE_PAYMENT: ["Duplicate (refund)", "bg-purple-50 text-purple-700"],
};
export const attemptLabel = (s) => (ATTEMPT_META[s] || [s || "—"])[0];
export const attemptTone = (s) => (ATTEMPT_META[s] || [null, "bg-gray-100 text-gray-700"])[1];
